import { applyInfluenceAnalysisMetricFilter } from '@process-advisor/process-miner/api/methods/influencer/applyInfluenceAnalysisMetricFilter';
import { setDiagramInfluenceAnalysis } from '@process-advisor/process-miner/api/methods/influencer/setDiagramInfluenceAnalysis'
import { setInfluenceAnalysisAttributes } from '@process-advisor/process-miner/api/methods/influencer/setInfluenceAnalysisAttributes';
import { applyInfluenceAnalysisValueFilter } from '@process-advisor/process-miner/api/methods/influencer/applyInfluenceAnalysisValueFilter';
import { setInfluenceAnalysisMinMaxMetric } from '@process-advisor/process-miner/api/methods/influencer/setMinMaxMetric'
import { getInfluenceAnalysisMinMaxMetric } from '@process-advisor/process-miner/api/methods/influencer/setMinMaxMetric'
import { setInfluenceAnalysisMinMaxTasks } from '@process-advisor/process-miner/api/methods/influencer/setMinMaxTasks'
import { getInfluenceAnalysisMinMaxTasks } from '@process-advisor/process-miner/api/methods/influencer/setMinMaxTasks'
import { setInfluenceShowSteps } from '@process-advisor/process-miner/api/methods/influencer/setShowSteps'
import { getInfluenceShowSteps } from '@process-advisor/process-miner/api/methods/influencer/setShowSteps'
import { updateDiagramInfluencers } from '@process-advisor/process-miner/api/methods/influencer/updateDiagramInfluencers'

export const influencerMethods = {
    applyInfluenceAnalysisMetricFilter,
    setInfluenceAnalysisAttributes,
    setDiagramInfluenceAnalysis,
    applyInfluenceAnalysisValueFilter,
    setInfluenceAnalysisMinMaxMetric,
    getInfluenceAnalysisMinMaxMetric,
    setInfluenceAnalysisMinMaxTasks,
    getInfluenceAnalysisMinMaxTasks,
    setInfluenceShowSteps,
    getInfluenceShowSteps,
    updateDiagramInfluencers
};
